Vendd.Scripts.load(function () {

    var $wrapper = $('.js-share-buttons-one');

    if ($wrapper.length < 1) {
        return;
    }

    var addthis_config = addthis_config || {};
    addthis_config.pubid = $wrapper.data('profile-id');

    function loadAddThis() {
        if (typeof addthis !== 'undefined') {
    		addthis.init();
    	}

    }

    loadAddThis();

});
